import { api } from "api/api";
import { LoginData, LoginResponse, mapLoginResponseData } from "api/shared/use-login";

export const mobileTransferAuth = async (code: string): Promise<LoginData> => {
  const url = `api/mobile/auth/transfer/${code}`;
  const response = await api.get<LoginResponse>(url);

  return mapLoginResponseData(response.data.data);
};
